import { render, staticRenderFns } from "./ProductPriceListEditorDialog.vue?vue&type=template&id=4d811046&scoped=true"
import script from "./ProductPriceListEditorDialog.vue?vue&type=script&lang=js"
export * from "./ProductPriceListEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceListEditorDialog.vue?vue&type=style&index=0&id=4d811046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d811046",
  null
  
)

export default component.exports